import { render, staticRenderFns } from "./edit-member-role.vue?vue&type=template&id=5845b08e&scoped=true"
import script from "./edit-member-role.vue?vue&type=script&lang=js"
export * from "./edit-member-role.vue?vue&type=script&lang=js"
import style0 from "./edit-member-role.vue?vue&type=style&index=0&id=5845b08e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845b08e",
  null
  
)

export default component.exports